const FEATURES = [
  "Match consented purposes to classified data elements in structured and unstructured stores",
  "Flag extra data present without a valid consent or legitimate purpose record",
  "Highlight missing consent where sensitive data was discovered",
  "Drive remediation — delete, restrict, or obtain fresh consent — with owners and deadlines",
];

const BADGE_CLASS = {
  match: "bg-[rgba(26,122,76,0.25)] text-[#6DDBA0]",
  extra: "bg-[rgba(196,92,38,0.25)] text-[#F0A070]",
  missing: "bg-[rgba(107,70,193,0.3)] text-[#C4B5FD]",
};

function Badge({ type, children }) {
  return (
    <span className={`text-[0.7rem] font-semibold px-[0.55rem] py-[0.22rem] rounded ${BADGE_CLASS[type]}`}>
      {children}
    </span>
  );
}

export default function ConsentVariance() {
  return (
    <section id="variance" className="py-20 bg-surface border-b border-line">
      <div className="container mx-auto max-w-[1140px] px-4">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.1fr] gap-10 items-center mt-10">
          <div>
            <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
              Consent Variance
            </p>
            <h2 className="font-bricolage text-[clamp(1.75rem,3vw,2.3rem)] mb-[0.7rem] text-ink">
              What was consented vs what data you actually hold
            </h2>
            <p className="text-[1.05rem] leading-[1.65] text-slate max-w-[40rem]">
              Seamless integration with Data Discovery &amp; Classification
              surfaces Consent Variance — so you can see when systems hold
              more personal data than consent (or notice) allows, and close
              the gap before it becomes a finding.
            </p>
            <ul className="list-none p-0 mt-6 mb-0">
              {FEATURES.map((f) => (
                <li
                  key={f}
                  className="flex gap-3 py-[0.7rem] border-b border-line text-[0.98rem] text-slate-2 last:border-b-0"
                >
                  <i className="bi bi-check2 text-teal text-[1.1rem] mt-[2px] flex-shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
          </div>

          <div
            className="relative rounded-2xl p-7 text-white overflow-hidden bg-ink2"
            aria-label="Consent variance preview"
          >
            <div
              className="absolute inset-0 pointer-events-none"
              style={{ background: "radial-gradient(circle at 90% 10%, rgba(11,143,122,0.25), transparent 45%)" }}
            />
            <div className="relative bg-white/[.05] border border-white/10 rounded-[10px] p-[1.15rem_1.25rem] mb-[0.85rem]">
              <div className="text-[0.68rem] tracking-[0.1em] uppercase text-teal-bright mb-[0.45rem]">
                Consent Variance · CRM Profile Store
              </div>
              <div className="flex justify-between items-center py-[0.55rem] border-b border-white/[.08] text-[0.9rem] text-white/[.82]">
                <span>Name &amp; contact</span>
                <Badge type="match">Consented</Badge>
              </div>
              <div className="flex justify-between items-center py-[0.55rem] border-b border-white/[.08] text-[0.9rem] text-white/[.82]">
                <span>Marketing preferences</span>
                <Badge type="match">Consented</Badge>
              </div>
              <div className="flex justify-between items-center py-[0.55rem] border-b border-white/[.08] text-[0.9rem] text-white/[.82]">
                <span>Government ID scan</span>
                <Badge type="extra">Extra data</Badge>
              </div>
              <div className="flex justify-between items-center py-[0.55rem] border-b border-white/[.08] text-[0.9rem] text-white/[.82]">
                <span>WhatsApp chat history</span>
                <Badge type="extra">Extra data</Badge>
              </div>
              <div className="flex justify-between items-center py-[0.55rem] text-[0.9rem] text-white/[.82]">
                <span>Location (precise)</span>
                <Badge type="missing">No consent</Badge>
              </div>
            </div>
            <div className="relative bg-white/[.05] border border-white/10 rounded-[10px] p-[1.15rem_1.25rem]">
              <div className="text-[0.68rem] tracking-[0.1em] uppercase text-teal-bright mb-[0.45rem]">
                Discovery link
              </div>
              <div className="flex justify-between items-center py-[0.55rem] border-b border-white/[.08] text-[0.9rem] text-white/[.82]">
                <span>Agent + agentless scan</span>
                <Badge type="match">Synced</Badge>
              </div>
              <div className="flex justify-between items-center py-[0.55rem] text-[0.9rem] text-white/[.82]">
                <span>Structured + unstructured</span>
                <Badge type="match">Covered</Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
